var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.864 12.858C12.718 13.004 12.526 13.078 12.334 13.078C12.142 13.078 11.95 13.004 11.803 12.858L9.997 11.051L8.196 12.853C7.903 13.146 7.428 13.146 7.135 12.853C6.843 12.56 6.843 12.086 7.135 11.793L8.936 9.991L7.134 8.188C6.841 7.895 6.841 7.421 7.134 7.128C7.427 6.835 7.901 6.835 8.194 7.128L9.997 8.93L11.798 7.129C12.091 6.837 12.565 6.837 12.858 7.129C13.151 7.422 13.151 7.897 12.858 8.19L11.058 9.991L12.864 11.797C13.157 12.09 13.157 12.565 12.864 12.858ZM14.217 0.5H5.782C2.622 0.5 0.5 2.72 0.5 6.026V13.974C0.5 17.279 2.622 19.5 5.782 19.5H14.216C17.376 19.5 19.5 17.279 19.5 13.974V6.026C19.5 2.72 17.377 0.5 14.217 0.5Z",
    fill: "#F92626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChat);
export default __webpack_public_path__ + "static/media/close-chat.58dd34c166c19a991da117c723e02cc1.svg";
export { ForwardRef as ReactComponent };